import type { TechnicalInfoDataDTO } from "~/Search/dto/SearchResultsDTO";
import Grid from "@mui/material/Grid";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList"; // Grid version 2
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import RenderServerSideContent from "~/common/components/RenderServerSideContent";

interface Props {
  data: TechnicalInfoDataDTO | null | undefined;
  cmsContent?: Element;
}

export const MoreInformationTab = (props: Props) => {
  const { t } = useTranslation();

  if (!props.data?.columns && !props.cmsContent) {
    return null;
  }

  return (
    <Stack
      sx={{
        gap: 8,
      }}
    >
      <Grid container rowSpacing={3}>
        {props.cmsContent && <RenderServerSideContent content={props.cmsContent} />}
        {props.data?.columns?.map((column) => (
          <Grid
            size={{
              phone: 12,
              "desktop-s": 4,
            }}
          >
            <LinkList key={column.title} title={column.title} seeMoreUrl={column.viewMoreURL}>
              {column.items.map((item) => (
                <LinkListItem
                  key={item.name}
                  href={item.pageUrl}
                  headline={t(item.name)}
                  subheadline={t(item.subheader)}
                  overline={t(item.overline)}
                  linkType={item.openInNewTab ? "NEWTAB" : "SAMETAB"}
                />
              ))}
            </LinkList>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
